<template>
  <div>
    <router-view name="modal"></router-view>
    <h3 class="app-name">
      <img :src="app.icon" />
      {{app.name === '0' ? productName : app.name}}
      <div class="hamburger" @click="toggleSidebar" :class="{isActive: showSidebar}" id="hamburger">
        <span class="line"></span>
        <span class="line"></span>
        <span class="line"></span>
      </div>
    </h3>
    <hr />
    <div class="center">
      <div id="sidebar">
        <div v-if="$authenticated.value" class="jstree-buttons">
          <b-button variant="primary" class="nuiteq-button" @click="createSectionNode()">New Section</b-button>
          <b-button
            variant="primary"
            class="nuiteq-button"
            @click="createArticleNode()"
            style="margin-left: 8px;"
          >New Article</b-button>
        </div>
        <div v-if="$authenticated.value" id="jstree"></div>
        <div v-if="!$authenticated.value" id="user-sidebar">
          <ul>
            <li
              v-for="node in app.tree"
              :key="node.id"
              :class="{ parent: node.data.articleId, alwaysVisible: true }"
            >
              <router-link
                v-if="!node.data.articleId"
                :to="{params: {sectionId: node.data.url, articleId: node.children[0].data.url}}"
              >{{node.text}}</router-link>
              <router-link
                v-else
                :to="{params: {sectionId: '0', articleId: node.data.url}}"
              >{{node.text}}</router-link>
              <ul v-if="node.children.length > 0">
                <li class="children" v-for="children in node.children" :key="children.id">
                  <router-link
                    :to="{params: {sectionId: node.data.url, articleId: children.data.url}}"
                  >{{children.text}}</router-link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <transition name="slide">
          <div v-if="!$authenticated.value && showSidebar" id="user-sidebar-mobile">
            <ul>
              <li
                v-for="node in app.tree"
                :key="node.id"
                :class="{ parent: node.data.articleId, alwaysVisible: true }"
              >
                <router-link
                  v-if="!node.data.articleId"
                  @click.native="showSidebar = false"
                  :to="{params: {sectionId: node.data.url, articleId: node.children[0].data.url}}"
                >{{node.text}}</router-link>
                <router-link
                  v-else
                  @click.native="showSidebar = false"
                  :to="{params: {sectionId: '0', articleId: node.data.url}}"
                >{{node.text}}</router-link>
                <ul v-if="node.children.length > 0">
                  <li class="children" v-for="children in node.children" :key="children.id">
                    <router-link
                      @click.native="showSidebar = false"
                      :to="{params: {sectionId: node.data.url, articleId: children.data.url}}"
                    >{{children.text}}</router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </transition>
      </div>
      <div id="articleView">
        <transition name="slide-left">
          <router-view name="articleView"></router-view>
        </transition>
        <div class="article-end">
          <div class="article-controls">
            <router-link
              v-if="previousArticle.url"
              :to="{params: {sectionId: previousSection, articleId: previousArticle.url}}"
            >
              <div class="footer-elements prev" style="visibility: visible;">
                <font-awesome-icon :icon="['fas', 'chevron-left']" />
                <a href="#" class="btn btn-neutral" title accesskey="p" rel="prev">
                  PREVIOUS
                  <br />
                  <span class="subtext-footerbtn">{{ previousArticle.title | truncate(11, '...', windowWidth) }}</span>
                </a>
              </div>
            </router-link>
            <router-link
              v-if="nextArticle.url"
              :to="{params: {sectionId: nextSection, articleId: nextArticle.url }}"
            >
              <div class="footer-elements next">
                <a href="#" class="btn btn-neutral" accesskey="n" rel="next">
                  NEXT
                  <br />
                  <span class="subtext-footerbtn">{{ nextArticle.title | truncate(11, '...', windowWidth) }}</span>
                </a>
                <font-awesome-icon :icon="['fas', 'chevron-right']" />
              </div>
            </router-link>
          </div>
          <hr style="min-width: 100%;" />
          <div class="article-feedback">
            <span>
              Was this help page useful?
              <a
                href="https://www.nuiteq.com/contact"
                target="_blank"
              >Send feedback</a>
            </span>
          </div>
          <div class="article-backlink">
            <span>
              <font-awesome-icon :icon="['fas', 'chevron-left']" />
              <router-link :to="{path: '/' + productRoute}">Back</router-link>
              to {{ productName }} applications
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import * as $ from 'jquery';
import 'jstree';

export default {
  name: 'AppDetails',
  data() {
    return {
      app: {},
      windowWidth: window.innerWidth,
      showSidebar: false,
      nextArticle: {
        url: '',
        title: ''
      },
      nextSection: '',
      previousArticle: {
        url: '',
        title: ''
      },
      previousSection: '',
      productName: '',
      productRoute: ''
    };
  },
  metaInfo() {
    return {
      title:
        (this.app.name === '0' ? '' : this.app.name + ' - ') + this.productName + ' | NUITEQ Knowledge Base'
    };
  },
  filters: {
    truncate: function (text, length, suffix, windowWidth) {
      if(windowWidth > 800){
        return text;
      } else {
        if (text.length > length) {
          return text.substring(0, length) + suffix;
        } else {
          return text;
        }
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    axios
      .get(
        process.env.VUE_APP_BASE_URL +
          '/' +
          to.params.productId +
          '/' +
          to.params.appId
      )
      .then(response => {
        // in case no section id (and article id) are given -> redirect to the first article that is inside the tree
        if (
          !to.params.sectionId &&
          response.data.app.tree &&
          response.data.app.tree[0]
        ) {
          if (response.data.app.tree[0].data.url){
            if (!response.data.app.tree[0].data.articleId) {
              if (response.data.app.tree[0].children[0]) {
                next(
                  '/' +
                    to.params.productId +
                    '/' +
                    to.params.appId +
                    '/' +
                    response.data.app.tree[0].data.url +
                    '/' +
                    response.data.app.tree[0].children[0].data.url
                );
              } else {
                next(
                  '/' +
                    to.params.productId +
                    '/' +
                    to.params.appId +
                    '/' +
                    response.data.app.tree[0].data.url
                );
              }
            } else {
              next(
                '/' +
                  to.params.productId +
                  '/' +
                  to.params.appId +
                  '/0/' +
                  response.data.app.tree[0].data.url +
                  '/'
              );
            }
          } else {
            next()
          }
        } else {
          next(vm => {
            vm.setData(response);
            let tree = response.data.tree;
            if (vm.$route.params.articleId) {
              vm.setPreviousAndNextArticle();
              vm.highlightCurrentNode();
            } else {
              if (vm.$route.params.sectionId) {
                if (vm.$route.params.sectionId === '0') {
                  for (let i = 0; i < tree.length; i++) {
                    if (tree[i].data) {
                      let articleUrl = tree[i].text
                        .replace(/ /g, '-')
                        .toLowerCase();
                      let path =
                        '/' +
                        vm.$route.params.productId +
                        '/' +
                        vm.$route.params.appId +
                        '/' +
                        vm.$route.params.sectionId +
                        '/' +
                        articleUrl;
                      vm.$router.push({ path: path });
                      break;
                    }
                  }
                } else {
                  for (let i = 0; i < tree.length; i++) {
                    if (!tree[i].data) {
                      let sectionUrl = tree[i].text
                        .replace(/ /g, '-')
                        .toLowerCase();
                      if (sectionUrl === vm.$route.params.sectionId) {
                        if (tree[i].children) {
                          let articleUrl = tree[i].children[0].text
                            .replace(/ /g, '-')
                            .toLowerCase();
                          let path =
                            '/' +
                            vm.$route.params.productId +
                            '/' +
                            vm.$route.params.appId +
                            '/' +
                            vm.$route.params.sectionId +
                            '/' +
                            articleUrl;
                          vm.$router.push({ path: path });
                          break;
                        }
                      }
                    }
                  }
                }
              } else if (tree && tree.length > 0) {
                if (tree[0].data) {
                  let articleUrl = tree[0].text
                    .replace(/ /g, '-')
                    .toLowerCase();
                  let path =
                    '/' +
                    vm.$route.params.productId +
                    '/' +
                    vm.$route.params.appId +
                    '/0/' +
                    articleUrl;
                  vm.$router.push({ path: path });
                } else {
                  if (tree[0].children.length > 0) {
                    let sectionUrl = tree[0].text
                      .replace(/ /g, '-')
                      .toLowerCase();
                    let articleUrl = tree[0].children[0].text
                      .replace(/ /g, '-')
                      .toLowerCase();
                    let path =
                      '/' +
                      vm.$route.params.productId +
                      '/' +
                      vm.$route.params.appId +
                      '/' +
                      sectionUrl +
                      '/' +
                      articleUrl;
                    vm.$router.push({ path: path });
                  }
                }
              }
            }
          });
        }
      })
      .catch(function (error) {
        if (error) {
          next({ path: '/404' })
        }
      });
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  methods: {
    setData(app) {
      this.app = app.data.app;
      this.productName = app.data.productName;
      this.productRoute = this.$route.params.productId;
    },
    toggleSidebar(){
      this.showSidebar = !this.showSidebar;
    },
    setPreviousAndNextArticle() {
      let t = this.app.tree;
      if (this.$route.params.sectionId == 0) {
        for (let i = 0; i < t.length; i++) {
          if (this.$route.params.articleId === t[i].data.url) {
            if (i === 0) {
              this.previousArticle.url = false;
              if (t[i + 1]) {
                if (t[i + 1].children[0]) {
                  this.setNextArticleAndSection(
                    t[i + 1].children[0].data.url,
                    t[i + 1].children[0].text,
                    t[i + 1].data.url
                  );
                } else {
                  this.setNextArticleAndSection(
                    t[i + 1].data.url,
                    t[i + 1].text,
                    '0'
                  );
                }
              } else {
                this.nextArticle.url = false;
              }
            } else if (i + 1 === t.length) {
              this.nextArticle.url = false;
              if (t[i - 1].children[0]) {
                this.setPreviousArticleAndSection(
                  t[i - 1].children[t[i - 1].children.length - 1].data.url,
                  t[i - 1].children[t[i - 1].children.length - 1].text,
                  t[i - 1].data.url
                );
              } else {
                this.setPreviousArticleAndSection(
                  t[i - 1].data.url,
                  t[i - 1].text,
                  '0'
                );
              }
            } else {
              if (t[i - 1].children[0]) {
                this.setPreviousArticleAndSection(
                  t[i - 1].children[t[i - 1].children.length - 1].data.url,
                  t[i - 1].children[t[i - 1].children.length - 1].text,
                  t[i - 1].data.url
                );
              } else {
                this.setPreviousArticleAndSection(
                  t[i - 1].data.url,
                  t[i - 1].text,
                  '0'
                );
              }
              if (t[i + 1].children[0]) {
                this.setNextArticleAndSection(
                  t[i + 1].children[0].data.url,
                  t[i + 1].children[0].text,
                  t[i + 1].data.url
                );
              } else {
                this.setNextArticleAndSection(
                  t[i + 1].data.url,
                  t[i + 1].text,
                  '0'
                );
              }
            }
          }
        }
      } else {
        for (let i = 0; i < t.length; i++) {
          if (t[i].data.url === this.$route.params.sectionId) {
            for (let n = 0; n < t[i].children.length; n++) {
              if (t[i].children[n].data.url === this.$route.params.articleId) {
                if (n === 0) {
                  if (i === 0) {
                    this.setPreviousArticleAndSection(false, '', false);
                  } else {
                    if (t[i - 1].children[0]) {
                      this.setPreviousArticleAndSection(
                        t[i - 1].children[t[i - 1].children.length - 1].data
                          .url,
                        t[i - 1].children[t[i - 1].children.length - 1].text,
                        t[i - 1].data.url
                      );
                    } else {
                      this.setPreviousArticleAndSection(
                        t[i - 1].data.url,
                        t[i - 1].text,
                        '0'
                      );
                    }
                  }
                  if (t[i].children[n + 1]) {
                    this.setNextArticleAndSection(
                      t[i].children[n + 1].data.url,
                      t[i].children[n + 1].text,
                      t[i].data.url
                    );
                  } else {
                    if (i + 1 === t.length) {
                      this.setNextArticleAndSection(false, '', false);
                    } else {
                      if (t[i + 1].children[0]) {
                        this.setNextArticleAndSection(
                          t[i + 1].children[0].data.url,
                          t[i + 1].children[0].text,
                          t[i + 1].data.url
                        );
                      } else {
                        this.setNextArticleAndSection(
                          t[i + 1].data.url,
                          t[i + 1].text,
                          ''
                        );
                      }
                    }
                  }
                } else if (n + 1 === t[i].children.length) {
                  if (t[i].children[n + 1]) {
                    this.setNextArticleAndSection(
                      t[i].children[n + 1].data.url,
                      t[i].children[n + 1].text,
                      t[i].data.url
                    );
                  } else {
                    if (i + 1 === t.length) {
                      this.setNextArticleAndSection(false, '', false);
                    } else {
                      if (t[i + 1].children[0]) {
                        this.setNextArticleAndSection(
                          t[i + 1].children[0].data.url,
                          t[i + 1].children[0].text,
                          t[i + 1].data.url
                        );
                      } else {
                        this.setNextArticleAndSection(
                          t[i + 1].data.url,
                          t[i + 1].text,
                          '0'
                        );
                      }
                    }
                  }
                  this.setPreviousArticleAndSection(
                    t[i].children[n - 1].data.url,
                    t[i].children[n - 1].text,
                    t[i].data.url
                  );
                } else {
                  this.setPreviousArticleAndSection(
                    t[i].children[n - 1].data.url,
                    t[i].children[n - 1].text,
                    t[i].data.url
                  );
                  this.setNextArticleAndSection(
                    t[i].children[n + 1].data.url,
                    t[i].children[n + 1].text,
                    t[i].data.url
                  );
                }
                break;
              }
            }
            break;
          }
        }
      }
    },
    setPreviousArticleAndSection(articleUrl, articleTitle, section) {
      this.previousSection = section;
      this.previousArticle.title = articleTitle;
      this.previousArticle.url = articleUrl;
    },
    setNextArticleAndSection(articleUrl, articleTitle, section) {
      this.nextSection = section;
      this.nextArticle.title = articleTitle;
      this.nextArticle.url = articleUrl;
    },
    highlightCurrentNode() {},
    generateUserTree() {
      this.app.tree;
    },
    generateTree() {
      this.app.tree;
      $('#jstree').jstree({
        themes: {
          theme: 'default',
          dots: false,
          icons: false
        },
        core: {
          data: this.app.tree,
          check_callback: true,
          themes: {
            name: 'proton',
            responsive: true,
            icons: false
          }
        },
        plugins: [
          'dnd',
          'types',
          'unique',
          'wholerow',
          'html_data',
          'contextmenu'
        ],
        types: {
          '#': {
            valid_children: ['section', 'article']
          },
          section: {
            valid_children: ['article']
          },
          article: {
            valid_children: []
          }
        },
        contextmenu: { items: this.context_menu, select_node: false }
      });
    },
    context_menu(node) {
      var tree = $('#jstree').jstree(true);
      var vm = this;
      var items = {
        Create: {
          separator_before: false,
          separator_after: false,
          label: 'Create',
          action: function() {
            if (!node.data.articleId) {
              vm.createArticle(articleId => {
                let newNode = node;
                newNode.type = 'Article';
                let $node = tree.create_node(newNode);
                tree.edit($node);
                let createdNode = $('#jstree')
                  .jstree(true)
                  .get_node($node);
                createdNode.data = { articleId: articleId, url: 'new-node' };
                vm.saveCurrentTree();
              });
            } else {
              // Not allowed
            }
          }
        },
        Rename: {
          separator_before: false,
          separator_after: false,
          label: 'Rename',
          action: function() {
            tree.edit(node);
          }
        },
        Edit: {
          separator_before: false,
          separator_after: false,
          label: 'Edit',
          action: function() {
            if (node.parent === '#') {
              vm.$router.push({
                path:
                  '/' +
                  vm.$route.params.productId +
                  '/' +
                  vm.$route.params.appId +
                  '/0/' +
                  node.data.url +
                  '/edit'
              });
            } else {
              let parentNode = $('#jstree')
                .jstree(true)
                .get_node(node.parent);
              vm.$router.push({
                path:
                  '/' +
                  vm.$route.params.productId +
                  '/' +
                  vm.$route.params.appId +
                  '/' +
                  parentNode.data.url +
                  '/' +
                  node.data.url +
                  '/edit'
              });
            }
          }
        },
        Remove: {
          separator_before: true,
          separator_after: false,
          label: 'Remove',
          action: function() {
            if (node.data.articleId) {
              if (confirm('Are you sure to remove this article?')) {
                vm.deleteArticle(node.data.articleId, () => {
                  tree.delete_node(node);
                  vm.saveCurrentTree();
                });
              }
            } else {
              if (confirm('Are you sure to remove this section?')) {
                if (node.children.length === 0) {
                  tree.delete_node(node);
                  vm.saveCurrentTree();
                } else {
                  for (let i = 0; i < node.children.length; i++) {
                    let children = $('#jstree')
                      .jstree(true)
                      .get_node(node.children[i]);
                    node.children[i];
                    children;
                    vm.deleteArticle(children.data.articleId, () => {
                      // Article deleted
                    });
                    if (i === node.children.length - 1) {
                      tree.delete_node(node);
                      vm.saveCurrentTree();
                    }
                  }
                }
              }
            }
          }
        }
      };
      if (!node.data.articleId) {
        delete items.Edit;
      } else {
        delete items.Create;
      }

      return items;
    },
    goToPrevious() {
      if (this.previousArticle) {
        if (this.$route.params.sectionId == 0) {
          this.$router.push({
            name: 'showArticle',
            params: {
              articleId: this.previousArticle,
              sectionId: this.previousSection
            }
          });
        } else {
          this.$router.push({
            name: 'showArticle',
            params: { articleId: this.previousArticle }
          });
        }
      }
    },
    goToNext() {
      if (this.nextArticle) {
        if (this.$route.params.sectionId == 0) {
          this.$router.push({
            name: 'showArticle',
            params: { articleId: this.nextArticle, sectionId: this.nextSection }
          });
        } else {
          this.$router.push({
            name: 'showArticle',
            params: { articleId: this.nextArticle }
          });
        }
      }
    },
    createSectionNode() {
      this.$route;
      var tree = $('#jstree').jstree(true);
      var parent = '#';
      var newNode = {
        text: 'new section',
        type: 'section',
        data: { url: 'new-section' }
      };
      var node = $('#jstree').jstree('create_node', parent, newNode, 'last');
      tree.edit(node);
      this.saveCurrentTree();
    },
    createArticleNode() {
      this.createArticle(articleId => {
        var tree = $('#jstree').jstree(true);
        var parent = '#';
        var newNode = {
          text: 'new article',
          type: 'article',
          data: { articleId: articleId, url: 'new-article' }
        };
        var node = $('#jstree').jstree('create_node', parent, newNode, 'last');
        tree.edit(node);
        this.saveCurrentTree();
      });
    },
    createArticle(cb) {
      axios
        .post(process.env.VUE_APP_BASE_URL + '/article', {})
        .then(response => {
          cb(response.data);
        })
        .catch(() => {});
    },
    deleteArticle(articleId, cb) {
      axios
        .delete(process.env.VUE_APP_BASE_URL + '/article/' + articleId, {})
        .then(() => {
          cb();
        })
        .catch(() => {});
    },
    saveCurrentTree() {
      let tree = $('#jstree')
        .jstree(true)
        .get_json();
      this.app.tree = tree;
      this.setPreviousAndNextArticle();
      axios
        .put(
          process.env.VUE_APP_BASE_URL +
            '/' +
            this.$route.params.productId +
            '/' +
            this.$route.params.appId +
            '/tree',
          tree
        )
        .then(() => {})
        .catch(() => {});
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      window.onresize = () => {
        this.windowWidth = window.innerWidth
      }
      if (this.$authenticated.value) {
        this.generateTree();
        let vm = this;

        $('#jstree')
          // listen for event
          .on('move_node.jstree.jstree', function() {
            // moved node via drag and drop
            vm.saveCurrentTree();
          })
          // create the instance
          .jstree();
        $('#jstree').on('select_node.jstree', function(e, data) {
          if (data.node.data.articleId) {
            let articleUrl = data.node.text.replace(/ /g, '-').toLowerCase();
            if (data.node.parents.length === 1) {
              vm.$router.push({
                name: 'showArticle',
                params: { articleId: articleUrl, sectionId: '0' }
              });
            } else {
              let parentNode = $('#jstree')
                .jstree(true)
                .get_node(data.node.parent);
              let sectionUrl = parentNode.text.replace(/ /g, '-').toLowerCase();
              vm.$router.push({
                name: 'showArticle',
                params: { articleId: articleUrl, sectionId: sectionUrl }
              });
            }
          } else {
            $('#jstree')
              .jstree(true)
              .deselect_node(data.node);
            $('#jstree')
              .jstree(true)
              .toggle_node(data.node);
            let sectionUrl = data.node.text.replace(/ /g, '-').toLowerCase(); //replace every space symbol with a "-" symbol + change uppercase to lowercase
            if (data.node.children.length > 0) {
              let childNode = $('#jstree')
                .jstree(true)
                .get_node(data.node.children[0]);
              let articleUrl = childNode.text.replace(/ /g, '-').toLowerCase();
              vm.$router.push({
                name: 'showArticle',
                params: { sectionId: sectionUrl, articleId: articleUrl }
              });
            } else {
              vm.$router.push({
                name: 'showFirstArticleOfSection',
                params: { sectionId: sectionUrl }
              });
            }
          }
        });

        $('#jstree')
          // listen for event
          .on('rename_node.jstree.jstree', function(e, data) {
            let newUrl = data.text.replace(/ /g, '-').toLowerCase();
            data.node.data.url = newUrl;
            vm.saveCurrentTree();
          })
          // create the instance
          .jstree();

        $('#jstree').on('open_node.jstree', function(e, data) {
          var nodesToKeepOpen = [];

          // get all parent nodes to keep open
          $('#' + data.node.id)
            .parents('.jstree-node')
            .each(function() {
              nodesToKeepOpen.push(this.id);
            });

          // add current node to keep open
          nodesToKeepOpen.push(data.node.id);

          // close all other nodes
          $('.jstree-node').each(function() {
            if (nodesToKeepOpen.indexOf(this.id) === -1) {
              $('#jstree')
                .jstree()
                .close_node(this.id);
            }
          });
        });
      }
    });
  },
  updated() {
    this.setPreviousAndNextArticle();
    this.highlightCurrentNode();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import "../assets/themes/style.css";

.nuiteq-button {
  margin-top: 12px;
  margin-bottom: 12px;
  width: 100px;
  padding: 4px;
  padding-top: 2px;
  padding-bottom: 2px;
  height: auto;
}
.app-name {
  text-align: center;
  font-size: 22px;
  padding-top: 5px;
  padding-bottom: 5px;
  margin-bottom: -15px;
  margin-right: 19px;
  
}
.app-name img {
  height: 24px;
  margin-right: 4px;
}
#sidebar {
  width: 240px;
  display: inline-block;
  overflow-x: hidden;
  position: static;
}

#sidebar a {
  color: #404040;
}

a.btn:focus {
  outline: none;
  box-shadow: none;
}

.footer-elements a {
  color: #483c68;
}

.footer-elements a:hover {
  color: #483c68;
  text-decoration: none;
}

a:hover {
  color: #483c68;
  text-decoration: none;
}

a {
  color: #483c68;
}

#spacer {
  width: 74px;
  background-color: white;
  height: 740px;
  display: inline-block;
}

#articleView {
  padding-left: 34px;
  padding-right: 20px;
  width: calc(100% - 480px);
  max-width: 1340px;
  min-height: 740px;
  height: auto;
  display: inline-block;
}
.ql-container img,
#articleView img,
img {
  max-width: 100% !important;
}

.article-controls-next {
  float: right;
}

.article-controls {
  height: 48px;
}

.center {
  margin-top: 32px;
  margin-left: auto;
  margin-right: auto;
  min-height: 43.75em;
  background: #fff;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  max-width: 82.25em;
}
.sidebar-item {
  display: block;
}

.hamburger .line {
  width: 25px;
  height: 2px;
  background-color: #212529;
  display: block;
  margin: 4px auto;
  -webkit-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.hamburger:hover {
  cursor: pointer;
}

#hamburger {
  margin-top: 6px;
  float: right;
  display: none;
}

#hamburger.isActive .line:nth-child(2) {
  opacity: 0;
}

#hamburger.isActive .line:nth-child(1) {
  -webkit-transform: translateY(6px) rotate(45deg);
  -ms-transform: translateY(6px) rotate(45deg);
  -o-transform: translateY(6px) rotate(45deg);
  transform: translateY(6px) rotate(45deg);
}

#hamburger.isActive .line:nth-child(3) {
  -webkit-transform: translateY(-6px) rotate(-45deg);
  -ms-transform: translateY(-6px) rotate(-45deg);
  -o-transform: translateY(-6px) rotate(-45deg);
  transform: translateY(-6px) rotate(-45deg);
}

.slide-enter-active, .slide-leave-active {
    transition: transform 0.2s ease;
}

.slide-enter, .slide-leave-to {
  transform: translateX(-100%);
  transition: all 150ms ease-in 0s
}

#user-sidebar li.children a, #user-sidebar-mobile li.children a {
  padding-left: 64px;
}

#user-sidebar ul, #user-sidebar-mobile ul {
  list-style-type: none;
  padding: 0px;
}

#user-sidebar .router-link-exact-active, #user-sidebar-mobile .router-link-exact-active {
  background-color: #f0b67f;
}

#user-sidebar li a, #user-sidebar-mobile li a {
  padding: 6px;
  width: 100%;
  padding-left: 32px;
  display: inline-block;
}

#user-sidebar li, #user-sidebar-mobile li {
  border-top: 1px solid lightgray;
}

#user-sidebar li.alwaysVisible:last-of-type, #user-sidebar-mobile li.alwaysVisible:last-of-type {
  border-bottom: 1px solid lightgray;
}

#user-sidebar-mobile {
  box-shadow: 10px 4px 12px -2px rgba(0,0,0,0.25);
  position: absolute;
  background: white;
  min-height: 100%;
  min-width: 200px;
  max-width: 100%;
  margin-top: -34px;
}

button:hover {
  color: #454545;
  background-color: #ef9743;
  border-color: #ef9743;
}

button {
  color: #454545;
  background-color: #f0b67f;
  border-color: #f0b67f;
  position: relative;
  z-index: 2;
  line-height: normal;
  font-size: 14px;
  display: inline-block;
  border-style: solid;
  text-decoration: none;
  padding: 9px 32px;
  font-family: Montserrat, Helvetica, Arial, sans-serif;
}

.footer-elements {
  max-width: 50%;
  display: inline-block;
}
.footer-elements.next {
  float: right;
}

@media screen and (max-width: 1029px) {
  #user-sidebar,
  #spacer {
    display: none;
  }
  #articleView {
    margin: auto;
    width: 90%;
    padding-left: 0px;
    padding-right: 0px;
  }
  #hamburger {
    display: block;
  }
}
</style>
